import { render, staticRenderFns } from "./RowBlockBuyingTourismInsurance.vue?vue&type=template&id=ade091a8&"
import script from "./RowBlockBuyingTourismInsurance.vue?vue&type=script&lang=js&"
export * from "./RowBlockBuyingTourismInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports